// extracted by mini-css-extract-plugin
module.exports = {"comp":"JE_comp__ZvxQB"};